module.exports = __webpack_public_path__ + "static/img/zhuanli-6.81f5ae53.png";